export var CHAIN_ID_SOLANA = 1;
export var CHAIN_ID_ETH = 2;
export var CHAIN_ID_TERRA = 3;
export var CHAIN_ID_BSC = 4;
export var CHAIN_ID_POLYGON = 5;
export var CHAIN_ID_ETHEREUM_ROPSTEN = 10001;
export var WSOL_ADDRESS = "So11111111111111111111111111111111111111112";
export var WSOL_DECIMALS = 9;
export var MAX_VAA_DECIMALS = 8;
